export default import.meta.ROLLDOWN_FILE_URL_xBz3j9AAj0dCUhi0Glx7Ow